// extracted by mini-css-extract-plugin
export var pillWrapper = "_ne-0";
export var showOverflow = "_ne-1";